export const CREATE_PO_FIELD_LABEL_CLASS = 'block text-[13px] font-semibold text-gray-700 mb-1.5';
